import {
  Box,
  Text,
  Flex,
  SimpleGrid,
  Img,
  Avatar,
  Heading,
} from '@chakra-ui/react';
import React from 'react';

// const ImgAndDetail: React.FC<{ imgSrc: string; detail: string }> = ({
//     detail,
//     imgSrc,
//   }) => (
//     <Flex align="center" columnGap="7px">
//       <Img src={imgSrc} boxSize="20px" />
//       <Text
//         fontSize="18px"
//         fontWeight="700"
//         lineHeight="150%"
//         color="text.mediumBlack"
//       >
//         {detail}
//       </Text>
//     </Flex>
//   );

// const  speakers=[
//     {
//       name: 'Aakriti Bamniyal',
//       email: 'aakriti@ivca.in',
//       phone: '+91 9711110011',
//       designation: 'Sr. Vice President, IVCA',
//       image: 'https://static.levocdn.com/WGLBUT82/6993100871211061165.jpg',
//     },
//     {
//       name: 'Aakriti Bamniyal',
//       email: 'aakriti@ivca.in',
//       phone: '+91 9711110011',
//       designation: 'Sr. Vice President, IVCA',
//       image: 'https://static.levocdn.com/WGLBUT82/6993100871211061165.jpg',
//     },

// ]

interface Speaker {
  name: string;
  designation?: string;
  image?: string;
  email?: string;
  phone?: string;
  gov?: boolean;
  fund?: string;
}

interface Props {
  speakers?: Speaker[];
  alphabeticalSort?: boolean;
}

const Speakers: React.FC<Props> = ({
  speakers = [],
  alphabeticalSort = true,
}) => {
  const sortedSpeakers = [...speakers].sort((a, b) => {
    const nameA = a.name.toLowerCase(); // Convert to lowercase for case-insensitive sorting
    const nameB = b.name.toLowerCase();

    // Convert each character's ASCII value to a number and compare

    let i = 0;
    while (i < Math.min(nameA.length, nameB.length)) {
      const charCodeA = nameA.charCodeAt(i);
      const charCodeB = nameB.charCodeAt(i);

      if (charCodeA !== charCodeB) {
        return charCodeA - charCodeB;
      }

      // Increment i without using ++ operator
      i += 1;
    }

    return nameA.length - nameB.length;
  });
  const mapSpeakers = alphabeticalSort ? sortedSpeakers : speakers;
  const isGovernmentSpeaker = speakers.length > 0 && speakers[0].gov;
  return (
    <>
      {isGovernmentSpeaker && (
        <Box mt={{ xs: '18px', lg: '12px' }}>
          <Heading
            color="secondaryPurple.900"
            fontSize={{ xs: '24px', lg: '34px' }}
            fontWeight="700"
            lineHeight="130%"
            textAlign="center"
          >
            Government Speakers
          </Heading>

          <Flex mt="1rem">
            <SimpleGrid
              columns={{ xs: 1, md: 2, lg: 3 }}
              w="100%"
              spacingX="24px"
              spacingY="24px"
              flexDir={{ xs: 'column', md: 'row' }}
            >
              {speakers.map((item, index) =>
                item.gov ? (
                  <Flex
                    key={index}
                    boxShadow="0px 1.85185px 3.14815px 0px rgba(49, 49, 49, 0.02), 0px 8.14815px 6.51852px 0px rgba(49, 49, 49, 0.04)"
                    w="100%"
                    maxW="354px"
                    bgColor="white"
                    border="1px solid"
                    borderColor="#ededed"
                    color="text.mediumBlack"
                    py="44px"
                    pl="40px"
                    pr="40px"
                    flexDir="column"
                    rowGap="15px"
                  >
                    <Flex columnGap="39px">
                      <Avatar
                        src={item?.image || 'https://bit.ly/broken-link'}
                        boxSize="48px"
                      />
                      <Box>
                        <Heading
                          fontSize="22px"
                          fontWeight="800"
                          color="inherit"
                        >
                          {item.name}
                        </Heading>
                        <Flex flexDir="column" mt="11px">
                          <Text
                            fontSize="15px"
                            fontWeight="700"
                            lineHeight="150%"
                            letterSpacing="-0.3px"
                            color="inherit"
                          >
                            {item?.designation}
                          </Text>

                          {item?.fund && (
                            <Text
                              fontSize="15px"
                              fontWeight="600"
                              lineHeight="150%"
                              letterSpacing="-0.3px"
                              color="gray"
                              mt="5px"
                              //   textTransform="capitalize"
                            >
                              {item?.fund}
                            </Text>
                          )}
                        </Flex>
                      </Box>
                    </Flex>
                  </Flex>
                ) : null
              )}
            </SimpleGrid>
          </Flex>
        </Box>
      )}
      <Box mt="50px">
        <Heading
          color="secondaryPurple.900"
          fontSize={{ xs: '24px', lg: '34px' }}
          fontWeight="700"
          lineHeight="130%"
          textAlign="center"
        >
          Speakers
        </Heading>
        {mapSpeakers?.length === 1 ? (
          mapSpeakers?.map((item, index) => (
            <Flex
              flex={1}
              alignItems="flex-start"
              key={`${item?.email}-${index}`}
              mt="12px"
              columnGap="88px"
              rowGap="8px"
              align={{ xs: 'flex-start', lg: 'center' }}
              flexDir={{ xs: 'column', lg: 'row' }}
            >
              {item?.name && (
                <Flex columnGap="12px" align="center">
                  <Img src="/svg/user-icon.svg" />
                  <Text
                    color="secondaryPurple.900"
                    fontSize={{ xs: '14px', lg: '16px' }}
                    fontWeight="600"
                    lineHeight="130%"
                    textTransform="capitalize"
                  >
                    {item?.name}
                  </Text>
                </Flex>
              )}
              {item?.designation && (
                // <Link href={`mailto:${item?.email}`} target="_blank">
                <Flex columnGap="12px" align="center">
                  <Img src="/svg/mail-icon.svg" />
                  <Text
                    color="secondaryPurple.900"
                    fontSize={{ xs: '14px', lg: '16px' }}
                    fontWeight="600"
                    lineHeight="130%"
                  >
                    {item?.designation}
                  </Text>
                </Flex>
                // </Link>
              )}
              {item?.fund && (
                // <Link href={`tel:${item?.fund}`}>
                <Flex columnGap="12px" align="center">
                  <Img src="/svg/call-icon.svg" />
                  <Text
                    color="secondaryPurple.900"
                    fontSize={{ xs: '14px', lg: '16px' }}
                    fontWeight="600"
                    lineHeight="130%"
                    // textTransform="capitalize"
                  >
                    {item?.fund}
                  </Text>
                </Flex>
                // </Link>
              )}
            </Flex>
          ))
        ) : (
          <Flex mt="1rem">
            <SimpleGrid
              columns={{ xs: 1, md: 2, lg: 3 }}
              w="100%"
              spacingX="24px"
              spacingY="24px"
              flexDir={{ xs: 'column', md: 'row' }}
            >
              {mapSpeakers.map((item, index) =>
                item.gov === false ? (
                  <Flex
                    key={index}
                    boxShadow="0px 1.85185px 3.14815px 0px rgba(49, 49, 49, 0.02), 0px 8.14815px 6.51852px 0px rgba(49, 49, 49, 0.04)"
                    w="100%"
                    maxW="400px"
                    bgColor="white"
                    border="1px solid"
                    borderColor="#ededed"
                    color="text.mediumBlack"
                    py="44px"
                    pl="40px"
                    pr="40px"
                    flexDir="column"
                    rowGap="15px"
                  >
                    <Flex columnGap="39px">
                      <Avatar
                        src={item?.image || 'https://bit.ly/broken-link'}
                        boxSize="48px"
                      />
                      <Box>
                        <Heading
                          fontSize="22px"
                          fontWeight="800"
                          color="inherit"
                        >
                          {item.name}
                        </Heading>
                        <Flex flexDir="column" mt="11px">
                          <Text
                            fontSize="15px"
                            fontWeight="700"
                            lineHeight="150%"
                            letterSpacing="-0.3px"
                            color="inherit"
                          >
                            {item?.designation}
                          </Text>

                          {item?.fund && (
                            <Text
                              fontSize="15px"
                              fontWeight="600"
                              lineHeight="150%"
                              letterSpacing="-0.3px"
                              color="gray"
                              mt="5px"
                              //   textTransform="capitalize"
                            >
                              {item?.fund}
                            </Text>
                          )}
                        </Flex>
                      </Box>
                    </Flex>
                  </Flex>
                ) : null
              )}
            </SimpleGrid>
          </Flex>
        )}
      </Box>
    </>
  );
};
export default Speakers;
